import { Modal, type ModalProps } from './Modal';

export function Callout({ children, attachTo, ...props }: ModalProps) {
    return (
        <Modal attachTo={attachTo} closeOnOutsideClick showArrow {...props}>
            {children}
        </Modal>
    );
}
